import { apiClient } from 'common/utils/api'
import * as z from 'zod'

const createMedicalHistoryDataSchema = z.object({
  userAnswers: z
    .object({
      question: z.string(),
      answer: z.string()
    })
    .array(),
  jwtToken: z.string()
})

export type CreateMedicalHistoryData = z.TypeOf<typeof createMedicalHistoryDataSchema>

export const createMedicalHistoryVisit = async (requestData: CreateMedicalHistoryData): Promise<void> => {
  const { jwtToken, ...rest } = requestData
  await apiClient(jwtToken).post('Events/medical-history', {
    json: {
      ...rest
    }
  })
}

interface Questions {
  [idPytania: string]: {
    questionTitle: string
    userChoice: string
  }
}

export const parseQuestions = (questions: Questions) => {
  return Object.keys(questions).map((key) => ({
    question: questions[key].questionTitle,
    answer: questions[key].userChoice
  }))
}
